module.exports = __webpack_public_path__ + "img/hugging_face.6b25e41d.gif";